import FloatingVue from 'floating-vue';

export default defineNuxtPlugin(() => {
  FloatingVue.options.themes['fp'] = {
    ...FloatingVue.options.themes.tooltip,
    '$resetCss': true,
  };
});
